import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const Main = styled.div`
  display: flex;
  gap: var(--space-250);
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-regular);
  color: var(--text-primary);
`

export const Description = styled.div`
  font-size: var(--font-size-300);
  font-style: normal;
  letter-spacing: var(--font-letter-spacing-loose);
  color: var(--text-secondary);
`

export const Icon = styled.div<{ width: number; aspectRatio: number | undefined }>`
  width: ${({ width }) => width}px;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio || 1};

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`
